import axios from 'axios';
import { Dispatch, SetStateAction } from 'react';
import { incorrectToken } from '../../../lib/utils/incorrectToken';
import * as Sentry from "@sentry/react";

interface onWorkStatusLoadBtnDailyProps {
  setEmployeeDataDaily: Dispatch<SetStateAction<any[]>>;
  apartmentContractIdx: string; // 아파트 계약 인덱스
  calYear: string;
  calMonth: string;
  calDate: string;
  calPlanned : string;
  setDailySchedulerLoading: Dispatch<SetStateAction<boolean>>;
}

export const onWorkStatusLoadBtnDaily = async ({
  setEmployeeDataDaily,
  apartmentContractIdx, // 아파트 계약 인덱스
  calYear,
  calMonth,
  calDate,
  calPlanned,
  setDailySchedulerLoading,
}: onWorkStatusLoadBtnDailyProps) => {
  const token = sessionStorage.getItem('token');
  const contractIdx = sessionStorage.getItem('contractIdx'); // 아파트 계약 인덱스

  if (!apartmentContractIdx) {
    return alert('단지를 선택해주세요');
  }

  //console.log('calPlnned: ', calPlanned);
  setDailySchedulerLoading(true);

  await axios
    .get(
      // `${process.env.COMMON_URL}/attendance/ac10030/attendancestatus/${apartmentContractIdx}?Year=${calYear}&Month=${calMonth}&Day=${calDate}`
      // `/sample/AC10-030-daily-sample.json`, // ✅ 목데이터 (2023-03-01, idx: 14)
      `${process.env.COMMON_URL}/attendance/ac10030/attendancestatus/${apartmentContractIdx}?Year=${calYear}&Month=${calMonth}&Day=${calDate}&Planned=${calPlanned}`,
      {
        headers: { tokenId: token },
      }
    )
    .then(res => {
      //console.log('onWorkStatusLoadBtnDaily(일간 근무현황 API확인): ',`${process.env.COMMON_URL}/attendance/ac10030/attendancestatus/${apartmentContractIdx}?Year=${calYear}&Month=${calMonth}&Day=${calDate}&Planned=${calPlanned}`);
      try {
        if (res.data.ErrorCode === 0) {
          setDailySchedulerLoading(false);
          setEmployeeDataDaily(res.data.Data);
        } else {
          Sentry.captureMessage(`Server Error : AC10-030 : ErrorCode: ${res.data.ErrorCode}\n\nErrorMsg: ${res.data.ErrorMsg}`);
          alert(`정상적으로 처리되지 않았습니다.\n\nErrorCode: ${res.data.ErrorCode}\n\nErrorMsg: ${res.data.ErrorMsg}`);
          setDailySchedulerLoading(false);
          setEmployeeDataDaily(res.data.Data);
        }

        incorrectToken(res);
      } catch (e) {
        Sentry.captureException(e);
        console.error(e);
        console.log(
          `ErrorCode: ${res.data.ErrorCode}, ErrorMsg: ${res.data.ErrorMsg}`
        );
      }
    });
};
